/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import EnvUtil from '../../utils/EnvUtil';
import { ShareContent } from '../bridge/ShareObject';

function loadWxSDK(): Promise<void> {
  return new Promise<void>((resolve) => {
    const script = document.createElement('script');
    const head = document.getElementsByTagName('head')[0];
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
    script.onload = () => {
      resolve();
    };
    head.appendChild(script);
  });
}

function requestSign(shareUrl: string): Promise<any> {
  const sUrl = shareUrl || '';
  return axios.get('https://account.wps.cn/p/wechat/mp/jsapi/signature', {
    params: {
      appid: 'wxc49dd9e02dbf03c8',
      url: sUrl,
    },
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        let ret = '';
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        ret = ret.substring(0, ret.lastIndexOf('&'));
        return ret;
      },
    ],
  });
}

function initConfig(
  shareContent: ShareContent,
  config: any,
  success: (res: any) => void,
  fail: (res: any) => void,
) {
  const title = shareContent.title;
  const desc = shareContent.desc;
  const icon = shareContent.icon;
  window.wx.config({
    debug: config.debug || EnvUtil.isTestRuntime(),
    appId: config.appId || '',
    timestamp: parseInt(config.timestamp) || 0,
    nonceStr: config.noncestr || '',
    signature: config.signature || '',
    openTagList: ['wx-open-launch-app'],
    jsApiList: config.jsApiList || [
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
      'onMenuShareQQ',
      'onMenuShareQZone',
      'hideMenuItems',
    ], // 必填，需要使用的JS接口列表
  });
  window.wx.error((res: any) => {
    fail(res);
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  window.wx.ready((res: any) => {
    window.wx.updateAppMessageShareData({
      title: title,
      desc: desc,
      link: window.location.href,
      imgUrl: icon,
      success: function () {
        console.log('updateTimelineShareData config ok');
      },
    });
    window.wx.updateTimelineShareData({
      title: title,
      desc: desc,
      link: window.location.href,
      imgUrl: icon,
      success: function () {
        console.log('updateTimelineShareData config ok');
      },
    });
    success(res);
  });
}

export default {
  loadWxSDK,
  requestSign,
  initConfig,
};
